import React from 'react';
import { Grid, Typography, makeStyles, Snackbar } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Assignment, AddCircle } from '@material-ui/icons';

const useStyles = makeStyles({
  root: {
    marginTop: 100,
  },
  horizontalLine: {
    border: '1px solid #9C27B0',
    color: '#9C27B0',
  },
  popUpTextStyle: {
    fontWeight: 600,
    fontSize: '14px',
    color: '#262626',
    lineHeight: 'bold',
  },
  clickableItem: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

const NotificationSnackBar = props => {
  const { lastJsonMessage, handlePopupClose, handlePopupOnclick, popupOpen, top, height } = props;
  const classes = useStyles();

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        style={{ width: '390px', height, top }}
        autoHideDuration={5000}
        onClose={handlePopupClose}
        open={popupOpen}
        onClick={handlePopupOnclick}
      >
        <Grid container direction="column" className={classes.clickableItem}>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{
                backgroundColor: '#EBD4EF',
                height: '40px',
                padding: '0px 10px 0px',
                borderRadius: '5px 5px 0px 0px',
              }}
            >
              <Grid item style={{ paddingTop: '4px' }}>
                <Assignment style={{ color: '#9C27B0' }} />
              </Grid>
              <Grid item style={{ paddingTop: '15px', marginLeft: '-10px', zIndex: 2 }}>
                <AddCircle
                  style={{ color: '#9C27B0', fontSize: '12px', borderRadius: '50px', backgroundColor: '#F6EBF8' }}
                />
              </Grid>
              <Grid item style={{ marginLeft: '5px' }}>
                <Typography className={classes.popUpTextStyle}>{lastJsonMessage}</Typography>
              </Grid>
              <Grid item style={{ marginLeft: 'auto' }}>
                <Typography className={classes.popUpTextStyle}> Now </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{ backgroundColor: '#E1BEE7', borderRadius: '0px 0px 5px 5px' }}
            >
              <Grid item style={{ width: '100%', margin: '0px 10px 10px 10px' }}>
                <div className={classes.horizontalLine} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Snackbar>
    </>
  );
};

NotificationSnackBar.propTypes = {
  lastJsonMessage: PropTypes.string.isRequired,
  handlePopupClose: PropTypes.func.isRequired,
  handlePopupOnclick: PropTypes.func.isRequired,
  popupOpen: PropTypes.bool.isRequired,
  height: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
};

export default NotificationSnackBar;
